import { Separator, HStack, Text } from "@chakra-ui/react"

interface LaneHeaderRendererProps {
  title: string;
  label?: string | null;
  laneId: string;
}

const LaneHeaderComponent = ({ title, label }: LaneHeaderRendererProps) => {
    return (
        <>
            <HStack justify={'space-between'} alignItems={{ base: 'flex-end' }}
                fontFamily={'Caveat'}
                fontWeight={'bold'}
            >
                <Text fontSize={'1.5rem'}>{title}</Text>
                <Text fontSize={'1rem'}>{label}</Text>
            </HStack>
            <Separator orientation='horizontal' background='gray' colorScheme='lightgray' py='1px' />
        </>
    )
}

export default LaneHeaderComponent;
